import { filtersHelper } from "@/utils";
import { companyModel } from "@/models/api/company.model";
import { departmentModel } from "@/models/api/department.model";
import { officeModel } from "@/models/api/office.model";
import { positionModel } from "@/models/api/position.model";

export const userModel = (data) => ({
  uuid: data.uuid,
  roleUUID: data.role_uuid || data.role?.uuid || null,
  role: data.role || null,
  firstName: data.first_name,
  lastName: data.last_name,
  fullName: data.full_name,
  email: data.email,
  userType: data.user_type,
  emailVerifiedAt: filtersHelper.getDateFormat(data.email_verified_at),
  phoneCode: data.phone_code,
  phone: data.phone,
  phoneIso: data.phone_iso,
  phoneVerifiedAt: filtersHelper.getDateFormat(data.phone_verified_at),
  image: data.image,
  iwowsoftEmployeeUuid: data.iwowsoft_employee_uuid,
  appAccess: data.app_access,
  portalAccess: data.portal_access,
  appLastLoginAt: filtersHelper.getDateTimeFormat(data.app_last_login_at),
  portalLastLoginAt: filtersHelper.getDateTimeFormat(data.portal_last_login_at),
  appLoginAttempt: data.app_login_attempt,
  portalLoginAttempt: data.portal_login_attempt,
  isOrientation: data.is_orientation,
  isSuperadmin: data.is_superadmin,
  isActive: data.is_active,
  createdAt: filtersHelper.getDateFormat(data.created_at),
  createdBy: data.created_by,
  updatedAt: filtersHelper.getDateFormat(data.updated_at),
  updatedBy: data.updated_by,
  deletedAt: filtersHelper.getDateFormat(data.deleted_at),
  deletedBy: data.deleted_by,
  permission: data.permission
    ? {
        ...data.permission,
        uuid: data.permission.uuid,
        articles: data.permission.articles,
        articleApproval: data.permission.article_approval,
        rnd: data.permission.rnd,
        orientations: data.permission.orientations,
        training: data.permission.training,
        task: data.permission.task,
        vehicleInsurances: data.permission.vehicle_insurances,
        properties: data.permission.properties,
        appUsers: data.permission.app_users,
        portalUsers: data.permission.portal_users,
        notifications: data.permission.notifications,
        configurations: data.permission.configurations,
        companies: data.permission.companies,
        offices: data.permission.offices,
        positions: data.permission.positions,
        departments: data.permission.departments,
        sportClub: data.permission.sport_club,
        events: data.permission.events,
        userAdmin: data.permission.user_admin,
        meetingRoom: data.permission.meeting_room,
        meetingRoomBookings: data.permission.meeting_room_bookings,
        galleryTour: data.permission.gallery_tour,
        createdAt: filtersHelper.getDateFormat(data.permission.created_at),
        createdBy: data.permission.created_by,
        updatedAt: filtersHelper.getDateFormat(data.permission.updated_at),
        updatedBy: data.permission.updated_by,
        deletedAt: filtersHelper.getDateFormat(data.permission.deleted_at),
        deletedBy: data.permission.deleted_by,
      }
    : null,
  userCompanies: (data.user_companies ?? []).map((item) => ({
    uuid: item.uuid,
    sequence: item.sequence,
    company: item.company ? companyModel(item.company) : null,
    department: item.department ? departmentModel(item.department) : null,
    office: item.office ? officeModel(item.office) : null,
    position: item.position ? positionModel(item.position) : null,
  })),
});
